import { z } from "zod/v4";

import { BaseNodeExecutionResultSchema } from "../node-execution-result";

import { BaseNodeDefinitionSchema } from "./base-node";
import { UserInputNodeConfigSchema } from "./input-requirement";

export const UserInputNodeDefinitionSchema = BaseNodeDefinitionSchema.extend({
  type: z.literal("user-input"),
  config: UserInputNodeConfigSchema,
});

export const UserInputNodeResultSchema = BaseNodeExecutionResultSchema.extend({
  type: z.literal("user-input"),
});

// TypeScript types inferred from Zod schemas
export type UserInputNodeResult = z.infer<typeof UserInputNodeResultSchema>;
export type UserInputNodeDefinition = z.infer<
  typeof UserInputNodeDefinitionSchema
>;
